import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import AddBeneficiaryBankAccountComponent from './component'

export const AddBeneficiaryBankAccount = combine({
  hooks: [
    withContext(
      'adminMemberService',
      ServicesContext,
      ({ adminMemberService }) => adminMemberService
    ),

    withCallbacks(
      {
        onSubmit:
          ({ adminMemberService }, { history, match }) =>
          async (bankAccountDTO) => {
            const beneficiaryId = Number(match.params.beneficiaryId)
            await adminMemberService.addMemberBankAccount(
              beneficiaryId,
              bankAccountDTO
            )
            toaster.info(
              'Beneficiary bank account has been successfully created'
            )
            history.push(admin.beneficiaries.invoices.view(beneficiaryId))
          },
      },
      []
    ),
  ],
  transformProps: ({ match, onSubmit }) => {
    return {
      beneficiaryId: Number(match.params.beneficiaryId),
      onSubmit,
    }
  },
})(AddBeneficiaryBankAccountComponent)
